import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function AdminPhotos() {
  const [photos, setPhotos] = useState([]);
  const [search, setSearch] = useState("");
  const [issue, setIssue] = useState("");
  const [date, setDate] = useState("");

  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const [flagForm, setFlagForm] = useState({
    issue_flag: "none",
    admin_notes: ""
  });

  useEffect(() => {
    fetchPhotos();
  }, []);

  const fetchPhotos = async () => {
    try {
      const res = await AdminAPI.get(
        `/photos?search=${search}&issue=${issue}&date=${date}`
      );

      setPhotos(res.data);

    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch photos");
    }
  };

  const openPhoto = async (id) => {
    try {
      const res = await AdminAPI.get(`/photos/${id}`);

      setSelectedPhoto(res.data);

      setFlagForm({
        issue_flag: res.data.issue_flag || "none",
        admin_notes: res.data.admin_notes || ""
      });

    } catch (err) {
      console.log(err);
      toast.error("Failed to load photo");
    }
  };

  const handleFlagChange = (e) => {
    setFlagForm({
      ...flagForm,
      [e.target.name]: e.target.value
    });
  };

  const saveFlag = async () => {
    try {
      await AdminAPI.put(
        `/photos/flag/${selectedPhoto.id}`,
        flagForm
      );

      toast.success("Issue flagged successfully");

      setSelectedPhoto(null);

      fetchPhotos();

    } catch (err) {
      console.log(err);
      toast.error("Failed to save issue");
    }
  };

  const deletePhoto = async (id) => {
    const confirmDelete = window.confirm(
      "Delete this photo?"
    );

    if (!confirmDelete) return;

    try {
      await AdminAPI.delete(`/photos/${id}`);

      toast.success("Photo deleted");

      fetchPhotos();

    } catch (err) {
      console.log(err);
      toast.error("Delete failed");
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        {/* FILTERS */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="d-flex gap-3 flex-wrap">
              <input
                type="text"
                className="form-control"
                placeholder="Search farmer..."
                style={{ width: "250px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <select
                className="form-select"
                style={{ width: "220px" }}
                value={issue}
                onChange={(e) => setIssue(e.target.value)}
              >
                <option value="">All Issues</option>
                <option value="none">No Issue</option>
                <option value="dry_bed">Dry Bed</option>
                <option value="high_moisture">High Moisture</option>
                <option value="fungus">Fungus</option>
                <option value="pests">Pests</option>
                <option value="overheating">Overheating</option>
                <option value="bad_odor">Bad Odor</option>
                <option value="other">Other</option>
              </select>

              <input
                type="date"
                className="form-control"
                style={{ width: "220px" }}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />

              <button
                className="btn btn-success"
                onClick={fetchPhotos}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* GALLERY */}
        <div className="row mt-4 g-4">
          {photos.map((photo) => (
            <div
              className="col-md-4 col-lg-3"
              key={photo.id}
            >
              <div className="card shadow border-0 h-100">
                <img
                  src={
                    photo.photo_path
                      ? `http://localhost:5010/uploads/${photo.photo_path}`
                      : "/images/no-image.png"
                  }
                  alt="farmer"
                  style={{
                    height: "220px",
                    objectFit: "cover",
                    cursor: "pointer"
                  }}
                  onClick={() => openPhoto(photo.id)}
                />

                <div className="card-body">
                  <h6>{photo.full_name}</h6>

                  <p className="small text-muted">
                    {photo.mobile}
                  </p>

                  <span
                    className={`badge ${
                      photo.issue_flag === "none"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                  >
                    {photo.issue_flag}
                  </span>

                  <div className="mt-3 d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => openPhoto(photo.id)}
                    >
                      View
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => deletePhoto(photo.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MODAL */}
        {selectedPhoto && (
          <div
            className="modal d-block"
            style={{
              background: "rgba(0,0,0,0.7)"
            }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">

                <div className="modal-header">
                  <h5>Photo Review</h5>

                  <button
                    className="btn-close"
                    onClick={() => setSelectedPhoto(null)}
                  />
                </div>

                <div className="modal-body">
                  <img
                    src={
                      selectedPhoto.photo_path
                        ? `http://localhost:5010/uploads/${selectedPhoto.photo_path}`
                        : "/images/no-image.png"
                    }
                    alt="preview"
                    className="img-fluid rounded"
                  />

                  <div className="mt-4">
                    <label className="form-label">
                      Issue Type
                    </label>

                    <select
                      name="issue_flag"
                      className="form-select"
                      value={flagForm.issue_flag}
                      onChange={handleFlagChange}
                    >
                      <option value="none">No Issue</option>
                      <option value="dry_bed">Dry Bed</option>
                      <option value="high_moisture">High Moisture</option>
                      <option value="fungus">Fungus</option>
                      <option value="pests">Pests</option>
                      <option value="overheating">Overheating</option>
                      <option value="bad_odor">Bad Odor</option>
                      <option value="other">Other</option>
                    </select>

                    <label className="form-label mt-3">
                      Admin Notes
                    </label>

                    <textarea
                      name="admin_notes"
                      className="form-control"
                      rows="4"
                      value={flagForm.admin_notes}
                      onChange={handleFlagChange}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setSelectedPhoto(null)}
                  >
                    Close
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={saveFlag}
                  >
                    Save Review
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default AdminPhotos;